import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchBalanceReportThunk = createAsyncThunk(
  "balanceReport/fetch",
  async (
    {
      ward_id = "",
      balance_type = "both",
      balance = "",
    },
    { rejectWithValue }
  ) => {
    try {
      const res = await api.get("/api/reports/balance-report", {
        params: {
          ward_id,
          balance_type,
          balance,
        },
      });

      if (!res.data?.success) {
        return rejectWithValue(
          res.data?.message || "Failed to load report"
        );
      }

      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
          err.message ||
          "Failed to load report"
      );
    }
  }
);

const balanceReportSlice = createSlice({
  name: "balanceReport",

  initialState: {
    rows: [],
    loading: false,
    error: null,
  },

  reducers: {
    clearBalanceReport: (state) => {
      state.rows = [];
      state.loading = false;
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchBalanceReportThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBalanceReportThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = action.payload || [];
      })
      .addCase(fetchBalanceReportThunk.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload || "Failed to load report";
      });
  },
});

export const {
  clearBalanceReport,
} = balanceReportSlice.actions;

export default balanceReportSlice.reducer;